export default __webpack_public_path__ + "static/media/green-2.8ec385e4.png";